var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.5C17.4853 26.5 19.5 24.4853 19.5 22C19.5 19.5147 17.4853 17.5 15 17.5C12.5147 17.5 10.5 19.5147 10.5 22C10.5 24.4853 12.5147 26.5 15 26.5Z",
    fill: "#E2EFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 28H4.5C2.84315 28 1.5 26.6569 1.5 25V4C1.5 2.34315 2.84315 1 4.5 1H25.5C27.1569 1 28.5 2.34315 28.5 4V25C28.5 26.6569 27.1569 28 25.5 28H23.25M15 26.5C17.4853 26.5 19.5 24.4853 19.5 22C19.5 19.5147 17.4853 17.5 15 17.5C12.5147 17.5 10.5 19.5147 10.5 22C10.5 24.4853 12.5147 26.5 15 26.5ZM15 26.5L15.0322 26.4997L10.243 31.2888L6.00037 27.0462L10.5295 22.5171M15 26.5L19.7892 31.2888L24.0319 27.0462L19.5028 22.5171M10.5 7H19.5M7.5 12.25H22.5",
    stroke: "#0D3355",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramIcon);
export default __webpack_public_path__ + "static/media/program-icon.4e671539.svg";
export { ForwardRef as ReactComponent };